import { COLOR_YELLOW_600, COLOR_YELLOW_700 } from '@alltrails/denali/tokens';
import { createParkPinSvg } from './svgMarkerComponents';

const nationalParkPinSvg = createParkPinSvg('national-park-pin', COLOR_YELLOW_600);
const activeNationalParkPinSvg = createParkPinSvg('active-national-park-pin', COLOR_YELLOW_700);

export { nationalParkPinSvg, activeNationalParkPinSvg };
